import { render, staticRenderFns } from "./PagoFallido.vue?vue&type=template&id=55261bae"
import script from "./PagoFallido.vue?vue&type=script&lang=js"
export * from "./PagoFallido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports